module.exports = "/img/_/_/_/assets/images/creeper/book/common//30.jpg?2bf3da85a4f0938717387a7d7093b44a";